import * as yup from 'yup'
import { ADMIN_FEEDBACK_VALUE } from 'Src/constants'

const validAdminFeedbackValues = Object.values(ADMIN_FEEDBACK_VALUE)

const validationSchema = yup
  .object()
  .shape({
    admin_feedback: yup.string().nullable().oneOf(validAdminFeedbackValues).required('Feedback is required'),
    relevant_content: yup
      .object()
      .shape({
        id: yup.number(),
        title: yup.string(),
        content_type: yup.string()
      })
      .nullable()
      .when('admin_feedback', {
        is: (value) => value === ADMIN_FEEDBACK_VALUE.NOT_RELEVANT,
        then: (schema) => schema.required('Relevant source is required')
      })
  })
  .required()

export default validationSchema
